import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCurrentTwitterMe } from "../api/AppLinkApi";
import { ProfileSkeleton, ProfileDisplay, ConnectedStatus } from "./components";

const TwitterSetting = ({ appInfo }) => {
  const { t } = useTranslation();

  const [connectedUser, setConnectedUser] = useState({
    picture: "",
    name: t("Anonymous"),
    username: "",
    id: "",
  });
  const [loading, setLoading] = useState(true);
  const [, setError] = useState<string | null>(null);

  useEffect(() => {
    if (appInfo.connected) {
      loadProfile();
    } else {
      setLoading(false);
      setError(null);
    }
  }, [appInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadProfile = () => {
    setLoading(true);
    setError(null);
    getCurrentTwitterMe()
      .then((data) => {
        setConnectedUser({
          picture: data?.profile_image_url || "",
          name: data?.name || t("Anonymous"),
          username: data?.username || "",
          id: data?.id || "",
        });
      })
      .catch((err) => {
        console.error("Failed to load Twitter profile:", err);
        setError(err?.response?.data?.message || err?.message || t("Failed to load profile"));
        // Keep existing user data on error instead of clearing
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-4 mb-4">
        <div className="col-span-12 lg:col-span-3">
          <div className={"w-40"}>{t("Twitter Profile")}</div>
        </div>
        <div className="col-span-12 lg:col-span-7">
          {appInfo.connected ? (
            loading ? (
              <ProfileSkeleton />
            ) : (
              <ProfileDisplay
                picture={connectedUser.picture}
                name={connectedUser.name}
                username={connectedUser.username}
                id={connectedUser.id}
              />
            )
          ) : (
            <div className="text-sm text-gray-500 py-2">
              {t("You need to connect your account first")}
            </div>
          )}
        </div>
        <div className="col-span-12 lg:col-span-2">{appInfo.connected && <ConnectedStatus />}</div>
      </div>
    </>
  );
};

export default TwitterSetting;
